import request from '@/utils/request'

// 列表
export function projects(data) {
  return request({
    url: 'admin/portal/project/list',
    method: 'post',
    data
  })
}

// 删除
export function deleteHandle(data) {
  return request({
    url: 'admin/portal/project/delete',
    method: 'post',
    data
  })
}

// 新增
export function save(data) {
  return request({
    url: 'admin/portal/project/save',
    method: 'post',
    data
  })
}

// 修改
export function update(data) {
  return request({
    url: 'admin/portal/project/update',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/portal/project/info/' + id,
    method: 'get'
  })
}

// 添加书签
export function addBookmark(data) {
  return request({
    url: 'admin/portal/project/addBookmark',
    method: 'post',
    data
  })
}

// 下一个书签
export function nextBookmark(data) {
  return request({
    url: 'admin/portal/project/nextBookmark',
    method: 'post',
    data
  })
}

// 上一个书签
export function previousBookmark(data) {
  return request({
    url: 'admin/portal/project/previousBookmark',
    method: 'post',
    data
  })
}

// 删除书签
export function delBookmark(data) {
  return request({
    url: 'admin/portal/project/delBookmark',
    method: 'post',
    data
  })
}

// 下拉信息初始化
export function initSelect() {
  return request({
    url: 'admin/portal/project/init',
    method: 'get'
  })
}
// 查询项目工地列表
export function listProjectConstructionSite(data) {
  return request({
    url: 'admin/data/projectConstructionSite/list',
    method: 'post',
    data
    })
}

// 查询项目工地详细
export function getProjectConstructionSite(siteId) {
  return request({
    url: 'admin/data/projectConstructionSite/' + siteId,
    method: 'get'
  })
}

// 新增项目工地
export function addProjectConstructionSite(data) {
  return request({
    url: 'admin/data/projectConstructionSite',
    method: 'post',
    data: data
  })
}

// 修改项目工地
export function updateProjectConstructionSite(data) {
  return request({
    url: 'admin/data/projectConstructionSite',
    method: 'put',
    data: data
  })
}

// 删除项目工地
export function delProjectConstructionSite(siteId) {
  return request({
    url: 'admin/data/projectConstructionSite/' + siteId,
    method: 'delete'
  })
}
// 查询工地检查列表
export function listProjectConstructionSiteInspect(data) {
  return request({
    url: 'admin/data/projectConstructionSiteInspect/list',
    method: 'post',
    data  })
}

// 查询工地检查详细
export function getProjectConstructionSiteInspect(inspectId) {
  return request({
    url: 'admin/data/projectConstructionSiteInspect/' + inspectId,
    method: 'get'
  })
}

// 新增工地检查
export function addProjectConstructionSiteInspect(data) {
  return request({
    url: 'admin/data/projectConstructionSiteInspect',
    method: 'post',
    data: data
  })
}
// 编辑地图
export function updateCoordinate(data) {
  return request({
    url: 'admin/prj/project/updateCoordinate',
    method: 'post',
    data: data
  })
}

// 修改工地检查
export function updateProjectConstructionSiteInspect(data) {
  return request({
    url: 'admin/data/projectConstructionSiteInspect',
    method: 'put',
    data: data
  })
}

// 删除工地检查
export function delProjectConstructionSiteInspect(inspectId) {
  return request({
    url: 'admin/data/projectConstructionSiteInspect/' + inspectId,
    method: 'delete'
  })
}
// 查询较大工程/超危工程列表
export function listProjectConstructionSitePartial(data) {
  return request({
    url: 'admin/prj/sitePartial/list',
    method: 'post',
    data
  })
}

// 查询较大工程/超危工程详细
export function getProjectConstructionSitePartial(siteId) {
  return request({
    url: 'admin/prj/sitePartial/info/' + siteId,
    method: 'get'
  })
}

// 新增较大工程/超危工程
export function addProjectConstructionSitePartial(data) {
  return request({
    url: 'admin/prj/sitePartial/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// 删除较大工程/超危工程
export function delProjectConstructionSitePartial(data) {
  return request({
    url: 'admin/prj/sitePartial/del',
    method: 'post',
    data
  })
}
// 查询机械设备列表
export function listProjectConstructionSiteEquip(data) {
  return request({
    url: 'admin/prj/siteEquip/list',
    method: 'post',
    data
  })
}

// 查询机械设备详细
export function getProjectConstructionSiteEquip(equipId) {
  return request({
    url: 'admin/prj/siteEquip/info/' + equipId,
    method: 'get'
  })
}

// 新增机械设备
export function addProjectConstructionSiteEquip(data) {
  return request({
    url: 'admin/prj/siteEquip/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// 删除机械设备
export function delProjectConstructionSiteEquip(data) {
  return request({
    url: 'admin/prj/siteEquip/del',
    method: 'post',
    data
  })
}
// 查询项目摄像头列表
export function listProjectCamera(data) {
  return request({
    url: 'admin/data/projectCamera/list',
    method: 'post',
    data  })
}

// 查询项目摄像头详细
export function getProjectCamera(id) {
  return request({
    url: 'admin/data/projectCamera/' + id,
    method: 'get'
  })
}

// 新增项目摄像头
export function addProjectCamera(data) {
  return request({
    url: 'admin/data/projectCamera',
    method: 'post',
    data: data
  })
}

// 修改项目摄像头
export function updateProjectCamera(data) {
  return request({
    url: 'admin/data/projectCamera',
    method: 'put',
    data: data
  })
}

// 删除项目摄像头
export function delProjectCamera(id) {
  return request({
    url: 'admin/data/projectCamera/' + id,
    method: 'delete'
  })
}
// 工地台账导出
export function siteExportData(data) {
  return request({
    url: 'admin/data/projectConstructionSite/exportData',
    method: 'post',
    responseType: 'blob',
    data
  })
}
